module.exports = __webpack_public_path__ + "img/DDP-Schematics-02.c6ad0f7c.svg";